import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import useDeleteConversation from '../../../../../../hooks/conversations/useDeleteConversation';
import { starIcon, scheduleIcon, userChefIcon, timerIcon  } from '../../../../../../utils/icons';
import useSignedImage from '../../../../../../hooks/useSignedImage';
import './employerConversationCard.css'

const EmployerConversationCard = ({ data, onConversationDeleted }) => {
  const [conversation, setConversation] = useState(null);
  const { handleDeleteConversation } = useDeleteConversation();
  const profileImage = data.employee.profileImageUrl;
  
  // Use signed image hook for employee profile image
  const { imageUrl: signedProfileImageUrl } = useSignedImage(
    profileImage, 
    '/default-employee.png'
  );

  const deleteConversation = async () => {
    try {
        await handleDeleteConversation(data.id);
        onConversationDeleted(); 
    } catch (error) {
        console.error('❌ Error deleting conversation:', error);
    }
  }

  return (
    <div className="employer-conversation-card__container">
      <div className="employer-conversation-card__col-1">
        <img 
          className="employer-conversation-card__image" 
          src={signedProfileImageUrl} 
          alt={data.name}
          onError={(e) => {
            e.target.src = '/default-employee.png';
          }}
        />
        <div className="employer-conversation-card__info">
          <p>{data.employee.name}</p>
        </div>
      </div>
      <div className='employer-conversation-card__col-2-container'>
        <div className="employer-conversation-card__col-2 ">
          <div className='employer-conversation-card__info-container'>
            <div className="employer-conversation-card__icon-container">
              {userChefIcon}
            </div>
            <div  className="employer-conversation-card__info-text-container">
              <p><strong>Cargo:</strong></p>
              <p>{data.employee.position}</p>
            </div>
          </div>
          <div className='employer-conversation-card__info-container'>
            <div className="employer-conversation-card__icon-container">
            {starIcon}
            </div>
            <div className="employer-conversation-card__info-text-container">
            <p><strong>Experiencia:</strong></p>
            <p>3 años</p> 
            </div>
          </div>
        </div>

        <div className="employer-conversation-card__col-2 ">
          <div className='employer-conversation-card__info-container'>
            <div className="employer-conversation-card__icon-container">
              {scheduleIcon}
            </div>
            <div className="employer-conversation-card__info-text-container">
            <p><strong>Disponibilidad:</strong></p>
            <p>{data.employee.available}</p>
            </div>
          </div>
          <div className='employer-conversation-card__info-container'>
            <div className="employer-conversation-card__icon-container">
              {timerIcon}
            </div>
            <div className="employer-conversation-card__info-text-container">
            <p><strong>Jornada:</strong></p>
            <p>{data.employee.schedule}</p>
            </div>
          </div>
        </div>
      </div>
      <div className='employer-conversation-card__col-3'>
        <div className="employer-conversation-card__button-container">
          <Link to={`/panel-empresa/inbox-empresa/${data.id}/${data.employeeId}`}>
            <button className="employer-conversation-card__button">Ver chat</button>
          </Link>
            <button className="employer-conversation-card__button" onClick={deleteConversation}>Eliminar</button>
        </div>
      </div>
    </div>
  );
};

export default EmployerConversationCard;
